import React, { useState } from 'react'
import { isUser } from '../../Config/isUser';
import { isCompany } from '../../Config/isCompany';

const MainSlider = () => {
  const [search_term, setSearch_term] = useState('');
  const handleChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setSearch_term(value)
  }
  return (
    <div className="jp_banner_heading_cont_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="jp_job_heading_wrapper">
              <div className="jp_job_heading">
                <h1>
                  İş ve staj ara
                </h1>
                <p>Biyomedikal mühendisleri için İş/Staj İmkanları</p>
              </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="jp_header_form_wrapper">
              <div style={{ marginRight: window.innerWidth > 1200 ? "550px" : "auto", marginLeft: window.innerWidth > 1200 ? "" : "auto" }} className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <input
                  onChange={handleChange}
                  type="text"
                  placeholder="İlanlarda ara"
                  style={{
                    width: window.innerWidth > 1200 ? "950px" : "100%",
                    maxWidth: "950px",
                    padding: "10px",
                  }}
                />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                <div className="jp_form_btn_wrapper">
                  <ul>
                    <li>
                      <a href={isUser ? (search_term === '' ? '/all-posts' : `/search-posts/${search_term}`) : (isCompany ? '/' : '/login')}>
                        <i className="fa fa-search" /> Ara
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="jp_banner_main_jobs_wrapper">
              <div className="jp_banner_main_jobs">
                <ul>
                  <li>
                    <i className="fa fa-tags" /> Popüler Anahtar Kelimeler :
                  </li>
                  <li>
                    <a href="/">
                      Satış</a>
                  </li>
                  <li>
                    <a href="/">Teknoloji Yönetimi</a>
                  </li>
                  <li>
                    <a href="/">Staj</a>
                  </li>
                  <li>
                    <a href="/">Üretim</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default MainSlider